// extracted by mini-css-extract-plugin
module.exports = {"IsDragging":"DraggablePlannedActivity_IsDragging__1958g","IsGhosting":"DraggablePlannedActivity_IsGhosting__1M37B"};